<template>
  <div class="d-flex-column justify-start align-start gap-24 mt-20">
    <GamePackBanner />

    <div
      class="d-flex-row align-start space-between xl-row-to-col gap-24 mobile-min-height"
    >
      <div class="d-flex-row flex-15 t-white" style="min-height: 48px">
        <div class="d-flex-column justify-start align-start gap-16">
          <SeasonLengthNew
            v-if="showSeasonLength"
            :season-length="getGame?.game_season"
          />
          <PackSelector />
        </div>
      </div>
      <!-- PACKS HERE -->
      <div
        class="d-flex-column flex-65 justify-start align-start t-white gap-24"
      >
        <div
          class="d-flex-column justify-start align-start"
          v-if="getGamePack.pack_slots"
        >
          <div class="warning_message d-flex-row justify-start cursor-pointer">
            <img
              src="/images/icons/warning-icon-2.webp"
              alt="warning_icon"
              height="48"
              width="48"
            />
            <p class="t-white font-family-2 medium-l cursor-pointer">
              {{ getGamePack.pack_slots?.season_title }}
            </p>
          </div>
        </div>

        <LazyCalculatorsRematchRankBoost
          v-if="currentGamePackSlug === 'rematch-rank-boost'"
        />
        <LazyCalculatorsRematchWinsBoost
          v-else-if="currentGamePackSlug === 'rematch-wins-boost'"
        />
        <LazyCalculatorsRematchPlacementsBoost
          v-else-if="currentGamePackSlug === 'rematch-placements-boost'"
        />
        <LazyCalculatorsRocketUnratedMatches
          v-else-if="currentGamePackSlug === 'rematch-unrated-matches-boost'"
        />
        <RematchPackDetail
          v-else-if="currentGamePackSlug === 'rematch-coaching-boost'"
        />

        <template v-if="currentGamePackSlug !== 'rematch-coaching-boost'">
          <div class="d-flex-column justify-start xl-hide" v-if="getPackFaq">
            <p
              class="t-orange regular-l f-w-500 font-family-1"
              style="letter-spacing: 2px"
            >
              {{ $t("homepage.faq") }}s
            </p>
            <Faq :faqs="getPackFaq" variant="pack" />
          </div>
        </template>
        <template v-else-if="currentGamePackSlug === 'rematch-coaching-boost'">
          <div class="d-flex-column justify-start align-start gap-6">
            <Info
              :title="$t('membership.membership_8_title')"
              v-if="gameStore.getGamePack?.rewards?.length > 0"
              :infos="gameStore.getGamePack?.rewards"
            />
            <Info
              :title="$t('new.requirements')"
              v-if="gameStore.getGamePack?.requirements?.length > 0"
              :infos="gameStore.getGamePack?.requirements"
            />
            <Info
              :title="$t('homepage.faq')"
              v-if="gameStore.getGamePack?.faqs?.length > 0"
              :infos="gameStore.getGamePack?.faqs"
              type="faq"
            />
          </div>
        </template>
      </div>

      <!-- CART HERE -->
      <div
        class="d-flex-column flex-2 justify-start align-start t-white cart_container"
      >
        <WhyWeCheap />

        <Cart />
        <SafeSecurePayments />

        <template v-if="currentGamePackSlug !== 'rematch-coaching-boost'">
          <div
            class="d-flex-column justify-start above-xl-hide"
            v-if="getPackFaq"
            style="margin-top: 24px"
          >
            <p
              class="t-orange regular-l f-w-500 font-family-1"
              style="letter-spacing: 2px"
            >
              {{ $t("homepage.faq") }}s
            </p>
            <Faq :faqs="getPackFaq" variant="pack" />
          </div>
        </template>
        <template v-else-if="currentGamePackSlug === 'rematch-coaching-boost'">
          <div class="d-flex-column justify-start align-start gap-6">
            <Info
              :title="$t('membership.membership_8_title')"
              v-if="gameStore.getGamePack?.rewards?.length > 0"
              :infos="gameStore.getGamePack?.rewards"
            />
            <Info
              :title="$t('new.requirements')"
              v-if="gameStore.getGamePack?.requirements?.length > 0"
              :infos="gameStore.getGamePack?.requirements"
            />
            <Info
              :title="$t('homepage.faq')"
              v-if="gameStore.getGamePack?.faqs?.length > 0"
              :infos="gameStore.getGamePack?.faqs"
              type="faq"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import GamePackBanner from "~/components/banners/GamePackBanner.vue";
import Cart from "~/components/calculators/checkout/Cart.vue";
import SafeSecurePayments from "~/components/calculators/checkout/SafeSecurePayments.vue";
import RematchPackDetail from "~/components/calculators/rematch/RematchPackDetail.vue";
import PackSelector from "~/components/common/sections/boosting/PackSelector.vue";
import Faq from "~/components/custom/Faq.vue";
import SeasonLengthNew from "~/components/custom/SeasonLengthNew.vue";
import WhyWeCheap from "~/components/custom/WhyWeCheap.vue";
import Info from "~/components/custom/Info.vue";
const gameStore = useGameStore();
const { getGamePack, getGame } = useGameStore();
const { currentGamePackSlug } = useGameComposable();

const getPackFaq = computed(() => {
  if (getGamePack?.faqs) {
    return getGamePack?.faqs;
  }

  return null;
});
const showWarning = ref(false);
const toggleWarning = () => {
  showWarning.value = !showWarning.value;
};
const showSeasonLength = computed(() => {
  if (!getGame?.id) return false;
  if (getGame?.game_season?.id) return true;
  return false;
});
</script>
